import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { GetAllTemplateMessage } from "src/formBuilder/formBuilder/formBuilder/formBuilder-viewModel";
import { BooleanType, ChartSeriesType, DataModel, DateType, FloatType, IntegerType, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../structure";
import  { DataModelBuilderView } from "./dataModelBuilder-view"
import { DataModelJsonSerializer } from "./serialization/dataModeltoJsonSerializer";
import { MethodManipulationViewModel } from "./methodManipulation/methodManipulation-viewModel";
import { PropertyManipulationViewModel } from "./propertyManipulation/propertyManipulation-viewModel";
import { DataModelFromJsonDeserializer } from "./serialization/dataModelFromJsonDeserializer";
import { FormBuilderWindowViewModel } from "src/formBuilder/formBuilder/formBuilderWindow-viewModel";
import { ServerSideDataLoader } from "uicomponents";
import { ExportViewModel } from "src/bpms/rawData/processDefinition/processForms/export/export-viewModel";
import { ImportViewModel } from "src/bpms/rawData/processDefinition/processForms/import/import-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DataModelToSourceCodeConverter } from "./datamodelToSourceCodeConverter";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { UnsavedChangesAreCreatedMessage } from "src/bpms/rawData/processDefinition/processForms/processForms-viewModel";
import { FindCurrentEditingProcessFormNameMessage, FindCurrentEditingProcessFormNameResult } from "src/bpms/rawData/processDefinition/processDefinition-viewModel";
import { WindowData } from "src";
import { SharedSelectors } from "src/erp/sharedSelectors";
export class DataModelBuilderViewModel extends ViewModel{
    static newWindowId:number =0;

    constructor(parentViewModel: FormBuilderWindowViewModel) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
        this.partName = 'Data Model';
        this.classes = ObservableArray.create<DataModelClass>();
    }
    GetDefaultView(): View <ViewModel> {
        return new DataModelBuilderView();
    }
    public getTypeId(): string {
        return "VM-08B81BB5-A201-472C-AA71-5B2636F3BBAC"
    }
    public typedParent : FormBuilderWindowViewModel;
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;
    public set partName(v: string) { this._partName = v; } public get partName(): string { return this._partName;} private _partName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    addNewClass() : DataModelClass{
        let result = new DataModelClass(this);
        this.classes.push(result);
        return result;
    }

    removeClass(cls:DataModelClass){
        this.classes.remove(cls);
    }
    public hasUnsavedChanges(){
        return this._isCodeChanged;
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllPropertyTypesMessage){
            msg.types = [
                new BooleanType(this),
                new IntegerType(this),
                new FloatType(this),
                new StringType(this),
                new ListType(this),
                new KnownClassType(this),
                new ServerSideDataLoaderType(this),
                new DateType(this),
                new ChartSeriesType(this)
            ];
            if(msg.allowVoid){
                msg.types.push(new VoidType(this));
            }
            return msg;
        }else if(msg instanceof GetAllClassesMessage){
            msg.classes = [...this.classes];
            return msg;
        }else{
            return super.handleMessage(msg);
        }
    }
    save(){
        try{
            this.typedParent.updateDataModel();
            this.handleMessage(new UnsavedChangesAreCreatedMessage());
            this.messageBoxConfirmSuccess("Data Model Updated Successfully.","Done");
        }catch{
            this.messageBoxConfirmWarning("Error Saving Data.","Error");
        }
    }
    getDataModelJson():any{
        return new DataModelJsonSerializer().serialize(this);
    }
    updateModelFromJson(json){
        this.classes.clear();
        if(json!=null)
            new DataModelFromJsonDeserializer().deserialize(this,json);
    }
    
    export(){
        let json = this.getDataModelJson();
        let exporter = new ExportViewModel(this);
        exporter.text = JSON.stringify(json);
        this.requestShowingPopup(exporter);
    }
    async import(){
        let importer = new ImportViewModel(this);
        let result = await this.requestShowingPopup(importer);
        if(stringIsNullOrEmpty(result)==false){
            let json = JSON.parse(result);
            this.updateModelFromJson(json);
        }
    }
    async LoadTypeings(){
        try {
            this.isLoading = true;
            
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    dispose() {
        this.disposeBus();
    }
    disposeBus(broadcastChannel?:BroadcastChannel){
        if(this._bus && (broadcastChannel==null || broadcastChannel==this._bus)){
            try{
                this._bus.postMessage({
                    type:'informClose'
                })
            }catch{}
            let index = WindowData.BroadCastChannels.indexOf(this._bus);
            WindowData.BroadCastChannels.splice(index,1);
            this._bus.close();
            this._bus = null;
        }else if(broadcastChannel){
            try{
                broadcastChannel.postMessage({
                    type:'informClose'
                })
            }catch{}
            
            let index = WindowData.BroadCastChannels.indexOf(broadcastChannel);
            WindowData.BroadCastChannels.splice(index,1);
            broadcastChannel.close();
        }

    }
    private _bus:BroadcastChannel;
    private _isCodeChanged : boolean;
    async edit(){
        this._isCodeChanged = false;
        if(this._bus){
            this.disposeBus();
        }
        let typingResult =await new TypingLoader().Load(this);
        let formNameResult = <FindCurrentEditingProcessFormNameResult>this.handleMessage(new FindCurrentEditingProcessFormNameMessage());
        let formName = `${formNameResult.ProcessName}/${formNameResult.FormName}`
        let handler =(msg:MessageEvent<any>)=>{
            let data = msg.data;
            switch(data.type){
                case "ready":
                    bus.postMessage({
                        type:'codeSend',
                        code : new DataModelToSourceCodeConverter().getSourceCode(this),
                        typings : typingResult.typings,
                        vmTypeings : typingResult.vmTypings,
                        sharedComboBoxTypings : typingResult.sharedComboBoxTypings,
                        name : formName
                    })
                    break;
                case "changed":
                    this._isCodeChanged = true;
                    break;
                case "newModel":
                    this._isCodeChanged = false;
                    let newModel = data.model;
                    let currentModel = this.getDataModelJson();
                    newModel.classes.forEach(cls => {
                        let relatedClasses = currentModel.classes.filter(x=>x.name==cls.name);
                        if(relatedClasses.length!=0){
                            let relatedClass = relatedClasses[0];
                            cls.properties.forEach(prop => {
                                let relatedProperties = relatedClass.properties.filter(x=>x.name==prop.name);
                                if(relatedProperties.length!=0){
                                    let relatedProperty = relatedProperties[0];
                                    if(prop.type==relatedProperty.type){
                                        prop.initialize = relatedProperty.initialize;
                                        prop.default = relatedProperty.default;
                                    }
                                }
                            });
                        }
                    });
                    this.updateModelFromJson(newModel);
                    break;
            }
        };
        DataModelBuilderViewModel.newWindowId = new Date().getTime();

        let bus :BroadcastChannel = new BroadcastChannel(`code-channel-${DataModelBuilderViewModel.newWindowId}`);
        WindowData.BroadCastChannels.push(bus);

        this._bus = bus;

        bus.onmessage = handler;
        
        let newWindow = window.open(`/codeEditor.html?a=${DataModelBuilderViewModel.newWindowId}`);

        newWindow.addEventListener('beforeunload',(e)=>{
            this.disposeBus(bus);
            console.log('unload');
        })
    }
}
export interface IMemberContainer{
    getName(): unknown;
    addNewProperty(p: Property);
    addNewMethod(m: Method);
    removeProperty(p:Property);
    removeMethod(m:Method);
    getDataModel():DataModelBuilderViewModel;
    getClass():DataModelClass;
    hasMethod(name:String):boolean;
}

export class DataModelClass extends ViewModel implements IMemberContainer{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DataModelBuilderViewModel) {
        super(parent);
        this.dataModel = parent;
        this.properties = ObservableArray.create<Property>();
        this.methods = ObservableArray.create<Method>();

    }

    
    public set dataModel(v: DataModelBuilderViewModel) { this._dataModel = v; } public get dataModel(): DataModelBuilderViewModel { return this._dataModel;} private _dataModel: DataModelBuilderViewModel;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
    public set properties(v: ObservableArray<Property>) { this._properties = v; } public get properties(): ObservableArray<Property> { return this._properties;} private _properties: ObservableArray<Property>;
    public set methods(v: ObservableArray<Method>) { this._methods = v; } public get methods(): ObservableArray<Method> { return this._methods;} private _methods: ObservableArray<Method>;
    
    getName(): unknown {
        return this.name;
    }
    hasMethod(name: String): boolean {
        return this.methods.filter(x=>x.name.trim()==name.trim()).length>0;
    }
    getDataModel(): DataModelBuilderViewModel {
        return this.dataModel;
    }
    getClass(): DataModelClass {
        return this;
    }
    
    async addProperty(){
        let popup = new PropertyManipulationViewModel(this);
        popup.cls = this;
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.properties.push(result);
        }
    }
    async addMethod(){
        let popup = new MethodManipulationViewModel(this);
        popup.cls = this;
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.methods.push(result);
        }
    }
    addNewProperty(p: Property) {
        this.properties.push(p);
    }
    addNewMethod(m: Method) {
        this.methods.push(m);
    }
    removeProperty(p:Property){
        this.properties.remove(p);
    }
    removeMethod(m:Method){
        this.methods.remove(m);
    }
}

export class Property extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.typedParent = <IMemberContainer><any>parent;
    }
    private typedParent : IMemberContainer;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set shallInitialize(v: boolean) { this._shallInitialize = v; } public get shallInitialize(): boolean { return this._shallInitialize;} private _shallInitialize: boolean;
    public set defaultValue(v: string) { this._defaultValue = v; } public get defaultValue(): string { return this._defaultValue;} private _defaultValue: string;
    public set type(v: PropertyType) { this._type = v; } public get type(): PropertyType { return this._type;} private _type: PropertyType;
    public set preBody(v: any) { this._preBody = v; } public get preBody(): any { return this._preBody;} private _preBody: any;
    public set postBody(v: any) { this._postBody = v; } public get postBody(): any { return this._postBody;} private _postBody: any;
    public set nullAllowanceBody(v: any) { this._nullAllowanceBody = v; } public get nullAllowanceBody(): any { return this._nullAllowanceBody;} private _nullAllowanceBody: any;
    

    remove(){
        this.typedParent.removeProperty(this);
    }

    async edit(){
        let popup = new PropertyManipulationViewModel(this);
        popup.cls = this.typedParent;
        popup.editProperty(this);
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.remove();
            this.typedParent.addNewProperty(result);
        }

    }
}

export class Method extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.typedParent = <IMemberContainer><any>parent;
        this.arguments = ObservableArray.create<methodParameters>();
    }
    private typedParent : IMemberContainer;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isAsync(v: boolean) { this._isAsync = v; } public get isAsync(): boolean { return this._isAsync;} private _isAsync: boolean;
    public set arguments(v: ObservableArray<methodParameters>) { this._arguments = v; } public get arguments(): ObservableArray<methodParameters> { return this._arguments;} private _arguments: ObservableArray<methodParameters>;
    public set returnType(v: PropertyType) { this._returnType = v; } public get returnType(): PropertyType { return this._returnType;} private _returnType: PropertyType;
    public set body(v: any) { this._body = v; } public get body(): any { return this._body;} private _body: any;
    
    remove(){
        this.typedParent.removeMethod(this);
    }

    async edit(){
        let popup = new MethodManipulationViewModel(this);
        popup.cls = this.typedParent;
        popup.editMethod(this);
        let result = await this.requestShowingPopup(popup);
        if(result!=null){
            this.remove();
            this.typedParent.addNewMethod(result);
        }

    }
}
export class methodParameters extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set type(v: PropertyType) { this._type = v; } public get type(): PropertyType { return this._type;} private _type: PropertyType;
    
}

export class GetAllPropertyTypesMessage extends ViewModelMessage{
    public types:PropertyType[];
    public allowVoid:boolean = false;
}
export class GetAllClassesMessage extends ViewModelMessage{
    public classes:DataModelClass[];
}

class TypingLoader{

    async Load(dataModelBuilder:DataModelBuilderViewModel):Promise<{typings:string,vmTypings:string,sharedComboBoxTypings:string}>{
        let [servicesResult,workFlowResults,reportResults] = await Promise.all([this.loadService(),this.loadWorkFlows(),this.loadReports()]);
        let serviceTypings = this.generateServiceTypings(servicesResult,workFlowResults);
        let vmTypings = this.generateVmTypings(dataModelBuilder);
        let reportTypings = this.generateReportTypings(reportResults);
        let templateTypings = this.generateTemplateTypings(dataModelBuilder);
        let sharedComboBoxTypings = this.generateSharedComboBoxTypings();
        let result = `${serviceTypings}
${templateTypings}        
${reportTypings}`;
        return {typings:result,vmTypings:vmTypings,sharedComboBoxTypings:sharedComboBoxTypings};
    }

    generateSharedComboBoxTypings():string{
        let validValues = [...SharedSelectors.Selectors.keys()].map(x=>`'${x}'`).join("|");
        let typingDeclaration = `declare type __SharedComboBoxValidTypes__ = ${validValues}`;
        return typingDeclaration;
    }
    generateTemplateTypings(dataModelBuilder: DataModelBuilderViewModel):string {
        let templates = dataModelBuilder.handleMessage(new GetAllTemplateMessage());
        let templateNames = templates.map(x=>x.name);
        let typeDefinition = `declare type TemplateTypesParams = ${templateNames.map(x=>`'return "${x}";'`).join('|')};`
        return typeDefinition;
    }
    private generateVmTypings(dataModelBuilder:DataModelBuilderViewModel){
        var classes = dataModelBuilder.classes;
        return `declare type ViewModelTypes = {
            ${classes.map(x=>`'${x.name}':${x.name};`).join('\n')}
        }`
    }
    async loadService():Promise<any>{
        let result = await ServerConnection.callServer('/Complex/ServiceManagement/GetAllServiceContractsInfo',{});
        return result;
    }
    async loadWorkFlows(){
        let result = await ServerConnection.callServer('/Complex/ServiceManagement/GetAllWorkFlowModelsInfo',{});
        return result;
    }
    async loadReports(){
        let result = await ServerConnection.callServer('/Complex/ServiceManagement/GetAllReportsInfo',{});
        return result;
    }
    private generateServiceTypings(serviceResult:any,workFlowResult:any):string{
        let workFlowTypings = this.generateWorkFlowInfo(workFlowResult);
        var allFlowNames = workFlowResult.Processes.map(x=>x.LocalName);
        let serviceTypings = serviceResult.Types.map(x=>this.generateSingleServiceType(x,allFlowNames));
        let types = [workFlowTypings,...serviceTypings].join('\n');
        let workFlowSpecifer = this.GenerateWorkFlowServiceSpecifier(serviceResult.Services);
        let inputParams = this.GenerateServiceInputParams(serviceResult.Services);
        let outputParams = this.GenerateServiceOutputParams(serviceResult.Services);
        let workFlowInputOutputMapping = this.generataWorkFlowServicesInputOutputMappings(serviceResult,workFlowResult,allFlowNames)
        return `${workFlowSpecifer}\n${types}\n${workFlowInputOutputMapping}\n${inputParams}\n${outputParams}`;
    }

    generataWorkFlowServicesInputOutputMappings(serviceResult: any, workFlowResult: any, allFlowNames: string[]) {
        let specificServiceReturnTypeResolver = []
        let serviceConstraints = [];
        serviceResult.Services.forEach(service => {
            if(service.IsWorkFlowSpecific){
                if(service.IsOutputWorkFlowSpecific){
                    specificServiceReturnTypeResolver.push(`declare type ${service.Output}Finder<T> = ${allFlowNames.map((x,i)=>`T extends ${service.Input}_${i+1}_NonGeneric ? ${service.Output}_${i+1}_NonGeneric `).join(' : ')}:any;`);
                }else{
                    specificServiceReturnTypeResolver.push(`declare type ${service.Output}Finder<T> = ${service.Output};`)
                }
                serviceConstraints.push(`T extends '${service.Path}' ? ${service.Output}Finder<U> `)
            }
        });
        let finalServiceConstraint = `declare type CallFunctionReturnTypeFinder<T extends keyof InputParams,U> = ServiceWorkFlowSpecifier[T] extends NotWorkFlowType ? OutputParams[T] : 
        ${serviceConstraints.join(' : ')} : OutputParams[T]`
        return `${specificServiceReturnTypeResolver.join('\n')}
${finalServiceConstraint}`
    }

    private generateWorkFlowInfo(workFlowResult:any):string{
        let workFlowTypings = workFlowResult.Types.map(x=>this.generateSingleWorkFlowType(x)).join('\n');
        let types = this.generateAllWorkFlowType(workFlowResult.Types);
        return `${workFlowTypings}
${types}`
    }

    private generateSingleWorkFlowType(type:any):string{
        let s = `declare interface ${type.Name}{
            ${type.Info.map(x=>`${x[0]}? : ${x[3]=='datetime'?'moment.Moment':x[3]=="numeric"?"number":x[3]}${'[]'.repeat(x[1])};`).join('\n')}
        }`
        return s;
    }
    private generateAllWorkFlowType(types:any[]){
        let s = `declare type AllWorkFlowTypes = {
    ${types.filter(x=>x.ProcessId!=null).map(x=>`'${x.LocalName}':${x.Name}`).join(',')}
};`
        return s;
    }
    private GenerateServiceInputParams(services:{Path:string,Input:string,Output:string}[]):string{

        return `declare type InputParams = {
    ${services.map(x=>`'${x.Path}' : ${x.Input};`).join('\n')}
}`;
    }
    private GenerateWorkFlowServiceSpecifier(services:{Path:string,Input:string,Output:string,IsWorkFlowSpecific:boolean}[]):string{

        return `
type IsWorkFlowType = {_e58e0afba5334f1b9f0441cf6ed493e3:string};
type NotWorkFlowType = {_5ba42601f925441eb20f6086bdbab5c6:string};        
declare type ServiceWorkFlowSpecifier = {
    ${services.map(x=>`'${x.Path}' : ${x.IsWorkFlowSpecific?'IsWorkFlowType':'NotWorkFlowType'};`).join('\n')}
}`;
    }
    private GenerateServiceOutputParams(services:{Path:string,Input:string,Output:string}[]):string{

        return `declare type OutputParams = {
    ${services.map(x=>`'${x.Path}' : ${x.Output};`).join('\n')}
}`;
    }
    private generateSingleServiceType(type:any,allFlowNames:string[]):string{
        let anyHasId = type.Info.filter(x=>x[4]==true).length>0;
        let anyHasContext = type.Info.filter(x=>x[5]==true).length>0;
        let needsGeneric = anyHasId || anyHasContext;
        let s = 
`declare interface ${type.Name}${needsGeneric ? `Generic<T extends keyof AllWorkFlowTypes>` : ''}{
    ${type.Info.map(x=>`${x[0]}? : ${x[4]==true ? 'T' : x[5]==true ? 'AllWorkFlowTypes[T]': x[3]=='datetime'?'moment.Moment':x[3]=="numeric"?"number":x[3]}${'[]'.repeat(x[1])};`).join('\n')}
}`;
        let typedInterfaces =''
        if(needsGeneric){
            typedInterfaces = allFlowNames.map((x,i)=>`declare interface ${type.Name}_${i+1}_NonGeneric extends ${type.Name}Generic<'${x}'>{}`).join('\n');
            let unionType = `declare type ${type.Name} = ${allFlowNames.map((x,i)=>`${type.Name}_${i+1}_NonGeneric`).join('|')};`;
            typedInterfaces = `${typedInterfaces}
${unionType}`;
        }
        return `${s}
${typedInterfaces}`;
    }
    private generateReportTypings(reportResult:any):string{
        let reportTypes = reportResult.Types.map(x=>this.generateSingleReport(x)).join('\n');
        let reportTypeDefinition = `declare type ReportTypeParams = {
    ${reportResult.Reports.map(x=>`'${x.Path}-${x.Name}-${x.Id}':${x.TypeName.replaceAll('-','')};`).join('\n')}
}`
    return `${reportTypes}
${reportTypeDefinition}`
    }
    private generateSingleReport(type:{Name:string,Info:any[]}):string{
        let className = `${type.Name.replaceAll('-','').trim()}`;
        let s = `declare interface ${className}{
            ${type.Info.map(x=>`${x[0]}? : ${x[3]=='datetime'?'moment.Moment':x[3]=="numeric"?"number":x[3].replaceAll('-','')}${'[]'.repeat(x[1])};`).join('\n')}
        }`;
        return s;
    }
}